import React from "react";
import ManageOrder from "../../components/ManageOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const ManagePharmacyOrder = () => {
  return <ManageOrder orderType={ORDER_TYPE.MEDICINES} />;
};

export default ManagePharmacyOrder;
